import { AUTH_ROUTES } from '../../constants/routePaths'
import auth_types from '../../constants/authTypes'
import {axios} from '../../services'

import { preferences_index } from '../preferencesActions'

const validate_token_request = () => {
  return {
    type: auth_types.VALIDATE_TOKEN.request
  }
}

const validate_token_success = (user) => {
  return {
    type: auth_types.VALIDATE_TOKEN.success,
    payload: user
  }
}

const validate_token_failure = (messages) => {
  return {
    type: auth_types.VALIDATE_TOKEN.failure,
    payload: messages
  }
}

const invalidate_user = () => {
  return {
    type: auth_types.VALIDATE_TOKEN.failure,
    payload: false
  }
}

// const validateToken = (userdata) => {
const validateToken = () => {
  return function (dispatch ) {
    // REQUEST
    dispatch(validate_token_request())

    axios.get(AUTH_ROUTES.VALIDATE_TOKEN,
      {
        data: {},
      }
    ).then( response => {
      // SUCCESS
      dispatch( validate_token_success( response ) )
      dispatch( preferences_index() )
    }).catch( error => {
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else if (error.response && error.response.data) {
        errors = [error.response.data]
      } else {
        errors = ["User validation failed."]
      }
      // FAILURE
      dispatch( validate_token_failure( errors ) )
    })
  }

}

const invalidateUser = () => {
  localStorage.removeItem('userdata')
  return invalidate_user()
}

export {
  validateToken,
  invalidateUser
}



// WEBPACK FOOTER //
// ./src/js/actions/auth/auth_validate_token.js